import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { AuthService } from "@app/services/auth.service";
import { IUser } from "@models";

@NgFilter({
    token: Token.IsAdminOrCompanyAdminFilter,
    dependencies: [
        Token.AuthService
    ]
})
export class IsAdminOrCompanyAdminFilter {
    constructor(
        private authService: AuthService
    ) {
        return ((user: IUser) => {
            return this.authService.isAdminOrCompanyAdmin();
        }) as any;
    }
}
